type AppcuesUserProperties = Record<string, string | number | boolean>;

interface AppcuesAPI {
  page: () => void;
  identify: (userId: string, properties?: AppcuesUserProperties) => void;
}

declare global {
  interface Window {
    Appcues?: AppcuesAPI;
  }
}

export const trackAppcuesPageView = () => {
  try {
    window.Appcues?.page();
  } catch {
    return;
  }
};

export const identifyAppcuesUser = (
  userId: string,
  properties: AppcuesUserProperties,
) => {
  try {
    window.Appcues?.identify(userId, properties);
  } catch {
    return;
  }
};

const INITIAL_PAGE_TRACK_RETRY_MS = 500;
const INITIAL_PAGE_TRACK_MAX_ATTEMPTS = 20;

type InitialPageTrackOptions = {
  isPageReady?: () => boolean;
};

export const trackInitialAppcuesPageView = ({
  isPageReady = () => true,
}: InitialPageTrackOptions = {}) => {
  let attempts = 0;
  const attempt = () => {
    const outOfBudget = attempts >= INITIAL_PAGE_TRACK_MAX_ATTEMPTS;
    if (window.Appcues && (isPageReady() || outOfBudget)) {
      trackAppcuesPageView();
      return;
    }
    attempts += 1;
    if (outOfBudget) return;
    setTimeout(attempt, INITIAL_PAGE_TRACK_RETRY_MS);
  };
  attempt();
};
